"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IronCrossMap = void 0;
exports.IronCrossMap = {
    "1 / 2": 0,
    "2 / 3": 1,
    "2 / 1": 2,
    "3 / 2": 3,
    "2 / 2": 4,
};
//# sourceMappingURL=IronCrossMap.js.map